/** Trigger a browser "Save as…" for an in-memory blob. */
export const triggerBlobDownload = (filename: string, blob: Blob): void => {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};
